// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import TCcontent from './PageComponent/T&C';

function TermsConditions() {

    useMeta({
        title: 'Terms & Conditions | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/terms-conditions/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Terms & Conditions | Callistus Blinds',
            description:
                'Welcome to www.callistusblinds.com, a website managed and maintained by Callistus Blinds. Callistus Blinds reserves the right to modify this Agreement at any time without giving you prior notice. Your use of the site following any such modification constitutes your agreement to follow and be bound by the Agreement as modified.',
            url: 'https://callistusblinds.com/terms-conditions/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <TCcontent />
            <Footer />
        </div>
    );
}

export default TermsConditions;
